const RETRY_COUNT = 5;
const RETRY_TIMEOUT = 1000;
export const scrollToElementWithRetry = (param, behavior = "smooth") => {
    if (!param)
        return;
    let attempts = 0;
    const scrollToElement = () => {
        attempts++;
        if (attempts >= RETRY_COUNT) {
            return;
        }
        const element = window.document.querySelector(`#${param}`);
        if (element) {
            element.scrollIntoView({ behavior });
        }
        else {
            setTimeout(scrollToElement, RETRY_TIMEOUT);
        }
    };
    scrollToElement();
};
//# sourceMappingURL=scrollToElementWithRetry.js.map